<template>
  <div id="pinkfongproduct-detail">
    <div
      v-if="loading"
      class="text-xs-center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>
    <detail
      v-if="item !== null && !loading"
      :item="item"
    >
      <template
        slot="content"
      >
        <div xs12>
          <!--가격 & 최소 주문 수량-->
          <div class="detail-row">
            <div v-if="isKorean()">
              <div class="detail-row-title">
                {{ $t("newLP.price") }}
              </div>
              <div class="detail-row-content">
                {{ item.price? parsePrice(item.price) : " - " }}
              </div>
            </div>
            <div class="detail-row-title">
              {{ $t("newCartPage.MOQ") }}
            </div>
            <div class="detail-row-content">
              {{ item.MOQ? item.MOQ : 1 }}
            </div>
          </div>
          <!--카테고리-->
          <div class="detail-row">
            <div class="detail-row-title">
              {{ $t("variables.category") }}
            </div>
            <div class="detail-row-content">
              {{ item.category ? item.category.name : '' }}
            </div>
          </div>
          <!--출시일-->
          <div class="detail-row">
            <div class="detail-row-title">
              {{ $t("variables.productReleaseDate") }}
            </div>
            <div class="detail-row-content">
              {{ item.release }}
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-row-title">
              IP
            </div>
            <div class="detail-row-content">
              {{ item.IP ? item.IP.name : '' }}
            </div>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-row-title">
            {{ $t('newLP.sound') }}
          </div>
          <div class="detail-row-content">
            {{ item.sound_language? item.sound_language.name : "" }}
          </div>
        </div>
        <br>
        <hr>
        <br>
        <b>[{{ $t("variables.productDescription") }}]</b>
        <div v-html="item.description" />
        <br>
        <div v-if="item.age"><b>{{ $t("variables.age") }}:</b> {{ item.age || '-' }}</div>
        <div v-if="item.size"><b>{{ $t("variables.productSize") }}: </b>{{ item.size || '-' }}</div>
        <div v-if="item.weight"><b>{{ $t("variables.weight") }}(g): </b>{{ item.weight || '-' }} g</div>
        <div v-if="item.weight_lbs"><b>{{ $t("variables.weight") }}(lbs): </b>{{ item.weight_lbs || '-' }} lbs</div>
        <div v-if="item.material"><b>{{ $t("variables.productMaterial") }}: </b>{{ item.material }}</div>
        <div v-if="item.box_size"><b>{{ $t("variables.boxSize") }} (B2B): </b>{{ item.box_size || '-' }}</div>
        <div v-if="item.box_weight"><b>{{ $t("variables.boxWeight") }} (kg): </b>{{ item.box_weight || '-' }} kg</div>
        <div v-if="item.box_weight_lbs"><b>{{ $t("variables.boxWeight") }} (lbs): </b>{{ item.box_weight_lbs || '-' }} lbs</div>
        <div v-if="item.packaging"><b>{{ $t("variables.productPackageType") }}: </b>{{ item.packaging || '-' }}</div>
        <div v-if="item.quantity"><b>{{ $t("variables.boxQuantity") }} (B2B): </b>{{ item.quantity || '-' }} ea</div>
        <br>
        <div v-if="item.battery"><b>{{ $t("variables.productBattery") }}: </b>{{ item.battery || '-' }}</div>
        <div v-if="item.barcode"><b>{{ $t("variables.productBarcode") }}: </b>{{ item.barcode || '-' }}</div>
        <div v-if="isKorean()">
          <b>KC 인증번호: </b>{{ item.KC_code || '-' }}
        </div>
        <div v-if="item.em_code"><b>{{ $t("variables.em_code") }} : </b>{{ item.em_code || '-' }}</div>
        <div v-if="item.isbn"><b>ISBN Number : </b>{{ item.isbn || '-' }}</div>
        <div v-if="item.HS_code_Indonesia"><b>HS CODE(Indonesia): </b>{{ item.HS_code_Indonesia || '-' }}</div>
        <div v-if="item.HS_code_Thailand"><b>HS CODE(Thailand): </b>{{ item.HS_code_Thailand || '-' }}</div>
        <div v-if="item.HS_code_US"><b>HS CODE(US): </b>{{ item.HS_code_US || '-' }}</div>
        <br>
        <div v-if="item.is_discontinued !== null && item.is_discontinued !== undefined"><b>{{ $t("variables.is_discontinued") }} : </b>{{ item.is_discontinued ? $t("variables.is_discontinued_true") : $t("variables.is_discontinued_false") }}</div>
        <div>
          <v-btn
            v-if="$route.params.lang === 'ko' && item.link !== null && item.link !== ''"
            :href="item.link"
            style="margin: 20px 0 0 0;"
            target="_blank"
          >
            핑크퐁 스토어에서 보기
          </v-btn>
        </div>
      </template>
      <template
        slot="auth-content"
      >
        <div>
          <br>
          <hr>
          <br>
          <p style="font-size: 26px;">내부 관리용 정보(외부 노출 x)</p>
          <div>
            <v-btn
              :href="`/admin/products/pinkfongproducts/${item.code}/change/`"
              style="margin: 20px 0 0 0;"
              target="_blank"
            >
              어드민에서 정보 수정하기
            </v-btn>
          </div>
          <br>
          <div v-if="item.uid"><b>UID:</b> {{ item.uid || '없음' }}</div>
          <div v-if="item.name_boxture"><b>제품명(박스쳐 품명):</b> {{ item.name_boxture || '없음' }}</div>
          <div v-if="item.sales_price"><b>판매가:</b> {{ item.sales_price || '없음' }}</div>
          <div v-if="item.planner_name"><b>제품 기획자:</b> {{ item.planner_name || '없음' }}</div>
          <div v-if="item.designer_name"><b>제품 디자이너:</b> {{ item.designer_name || '없음' }}</div>
          <div v-if="item.producer_name"><b>제품 제작자:</b> {{ item.producer_name || '없음' }}</div>
          <div v-if="item.produce_compony_name"><b>제작업체명:</b> {{ item.produce_compony_name || '없음' }}</div>
          <div v-if="item.project_code"><b>프로젝트 코드:</b> {{ item.project_code || '없음' }}</div>
          <br>
          <b>[음원 정보]</b>
          <div class="music-performer-info-sheet-wrap">
            <div class="music-performer-info-sheet">
              <v-table>
                <thead>
                  <tr>
                    <th class="text-left">
                      곡명
                    </th>
                    <th class="text-left">
                      아티스트명
                    </th>
                    <th class="text-left">
                      앨범명
                    </th>
                    <th class="text-left">
                      VIMS 코드
                    </th>
                    <th class="text-left">
                      UCI 코드
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="row in item.music_performer_info"
                    :key="row.uci_code"
                  >
                    <td>{{ row.song_name }}</td>
                    <td>{{ row.artist_name }}</td>
                    <td>{{ row.album_name }}</td>
                    <td>{{ row.vims_contents_code }}</td>
                    <td>{{ row.uci_code }}</td>
                  </tr>
                </tbody>
              </v-table>
            </div>
          </div>
        </div>
        <br>
        <br>
        <hr>
      </template>
      <template
        slot="buttons"
      >
        <v-layout
          row
          wrap
          align-center
          justify-center
        >
          <v-flex
            v-if="item.option.length > 0"
            class="card-info-action"
            xl12
            lg12
            md12
            sm12
            xs12
          >
            <multiselect
              v-model="selectedOption"
              track-by="code"
              label="name"
              :options="item.option ? item.option : []"
              :searchable="false"
              :allow-empty="false"
              :show-labels="false"
              open-direction="bottom"
              :placeholder="$t('newLP.selectOption')"
              style="width: 100%"
              @input="onSelectedOptionChanged('pinkfongproducts', item)"
            >
              <template
                slot="singleLabel"
                slot-scope="{ option }"
              >
                {{ option.name }}
              </template>
            </multiselect>
          </v-flex>
          <v-flex
            class="card-info-action"
            xl12
            lg12
            md12
            sm12
            xs12
          >
            <v-btn
              id="add-to-cart-btn"
              :style="{ backgroundColor: addToCartBtnColor }"
              @click="addToCart('pinkfongproducts', item)"
            >
              <div
                v-if="!isChecked"
                class="btn-text-field"
              >
                {{ $t("newLP.addCart") }}
              </div>
              <div
                v-if="isChecked"
                class="btn-text-field"
              >
                <div> {{ $t("newLP.alreadyAdded") }} </div>
                <i
                  class="icon material-icons"
                  style="padding-bottom: 8px; padding-left: 10px;"
                >
                  done
                </i>
              </div>
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
    </detail>
    <detail
      v-if="item === null && !loading"
      :item="item"
    >
      <template
        slot="not-found"
      >
        <div id="selected-products-empty">
          <img
            :src="require('../../assets/empty_cart.png')"
            style="margin-left: -33px;"
          >
          <p id="selected-products-empty-title">
            404 Not Found
          </p>
        </div>
      </template>
    </detail>
  </div>
</template>

<script>
import Detail from 'components/Detail.vue'
import Swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
const DEFAULT_ADD_TO_BTN_COLOR = 'rgb(255, 104, 175)'

export default {
  components: {
    'detail': Detail,
    Multiselect,
    Detail
  },
  data () {
    return {
      item: {
        option: [],
        category: { name: '' }
      },
      loading: false,
      selectedOption: null,
      isChecked: false,
      addToCartBtnColor: DEFAULT_ADD_TO_BTN_COLOR
    }
  },
  watch: {
    '$store.getters.selected' () {
      this.updateChecked('pinkfongproducts', this.item)
    },
    '$route.params.id' () {
      this.initUI()
      window.scrollTo(0, 0)
      this.getProductDetail()
    }
  },
  beforeMount () {
    window.scrollTo(0, 0)
    this.getProductDetail()
  },
  methods: {
    initUI () {
      this.loading = false
      this.selectedOption = null
      this.isChecked = false
    },
    getProductDetail: function () {
      this.loading = true
      this.$http.get('/api/products/pinkfongproducts/' + this.$route.params.id + '/?lang=' + this.$route.params.lang).then(res => {
        this.item = res.data
        this.updateChecked('pinkfongproducts', this.item)
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.item = null
        console.error(err)
      })
    },
    getOrderCode (item) {
      const orderCode = item.option.length === 0 ? item.code : this.selectedOption.code
      return orderCode
    },
    updateChecked (product, item) {
      // 옵션 존재 상품인데 아직 미 선택 상태일 경우 false 리턴
      if (item.option.length > 0 && !this.selectedOption) {
        this.addToCartBtnColor = DEFAULT_ADD_TO_BTN_COLOR
        return false
      }

      const orderCode = this.getOrderCode(item)
      const isChecked = this.$store.getters.isCheckedItem(product, orderCode)
      if (isChecked) {
        this.addToCartBtnColor = 'rgb(255, 154, 201)'
        this.isChecked = true
      } else {
        this.addToCartBtnColor = DEFAULT_ADD_TO_BTN_COLOR
        this.isChecked = false
      }
    },
    parsePrice (price) {
      if (price.value === 0) {
        return ' - '
      }
      return price.unit + price.value.toLocaleString()
    },
    onSelectedOptionChanged (product, item) {
      this.updateChecked(product, item)
    },
    addToCart (product, item) {
      if (item.option.length > 0 &&
          !this.selectedOption &&
          !this.isChecked) {
        Swal.fire({
          title: this.$t('newLP.noOptions'),
          icon: 'error'
        })
        return
      }
      const orderCode = this.getOrderCode(item)
      const payload = {
        ...item,
        orderCode,
        orderQuantity: item.MOQ || 1,
        orderDescription: '',
        product
      }

      this.$store.commit('toggleItem', payload)
      this.updateChecked(product, payload)
    }
  }
}
</script>
<style>
  ul {
    line-height: 1em;
  }

  #pinkfongproduct-detail .detail-row {
    white-space: nowrap;
  }

  #pinkfongproduct-detail .detail-row .detail-row-title {
    margin: 0px;
    padding-top: 10px;
    font-size: 14px;
  }

  #pinkfongproduct-detail .detail-row .detail-row-content{
    margin: 0px;
    padding-top: 0px;
    font-size: 20px;
  }
  #pinkfongproduct-detail .card-info-action{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
    max-width: 300px;
  }

  #pinkfongproduct-detail #add-to-cart-btn{
    margin: 0px;
    width: 100%;
    height: 40px;
    text-transform: inherit;
    background-color: #5a5a5a;
    color: white;
    font-weight: bold;
  }

  #pinkfongproduct-detail #add-to-cart-btn .selected{
    margin:0px;
    width: 100%;
    height: 45px;
    text-transform: inherit;
    background-color: #5a5a5a;
    color: white;
    font-weight: bold;
  }

  #pinkfongproduct-detail #add-to-cart-btn .btn-text-field{
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .music-performer-info-sheet-wrap {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: no-wrap;
  }

  .music-performer-info-sheet {
    min-width: 800px;
  }

  .music-performer-info-sheet th{
    border-top: 1px solid #868686;
    position: sticky;
    top: 0px;
    background-color: #e5e5e5;
  }

  .music-performer-info-sheet th:last-child, .music-performer-info-sheet td:last-child{
    border-right: 1px solid #868686;
  }

  .music-performer-info-sheet th, .music-performer-info-sheet td{
    min-width: 200px;
    border-left: 1px solid #868686;
    border-bottom: 1px solid #868686;
    text-align: left;
    word-break: break-all;
    padding: 5px;
  }

  .music-performer-info-sheet td{
    background-color: #ffffff;
  }

  #selected-products-empty{
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 80px;
    flex-direction: column;
  }

  #selected-products-empty #selected-products-empty-title{
    padding-top: 30px;
    margin: 0px;
    font-size: 24px;
    color: rgba(146, 146, 146, 0.9)
  }
</style>



// WEBPACK FOOTER //
// src/app/contents/PinkfongProductDetail.vue